import Stars from './Stars';
import homeStyles from "../Styles/Home.module.css"

export default function FlatListItem(props) {
    const { onClick, type, item } = props;
    
    let x;
    if (type === 'service') {
        x = item.type;
    } else if (type === 'venue') {
        x = item.address?.replace(/\s+/g, '');
    }
    const id = item.name?.replace(/\s+/g, '') + item.price + x;
    
    return (
        <div id={homeStyles.flatListItem} className='flatListItem'
            style={{
                // backgroundColor: 'black',
                // display: 'flex',
                // borderRadius: 10,
                // alignSelf: 'center',
                // padding: 5,
                // width: '100%',
                // flexDirection: 'row',
                // boxShadow: '0px 3px 5px rgb(0,0,0, 0.5)',
                // overflow: 'hidden',
                // margin: 5,
                // position: 'relative ',
                // zIndex: 2
            }}
            onClick={onClick}
        >
            {type && type === 'service' && <img
                alt={item.name +  " cover image"}
                style={{width: '100px', height: '100px', borderRadius: 10, objectFit: 'cover'}}
                src={item.photo ? item.photo : '/blank-profile-picture.png'}
            />}
            {item.images && item.images.cover &&
                <img
                alt={item.name +  " cover image"}
                src={ item.images.cover }
                style={{ height: 50 }}
                />}
                
            <div style={{ paddingInline: 10, justifyContent: 'space-between', flex: 1,  flexDirection: 'row', minHeight: 100, cursor: 'pointer'}}>
                <div  style={{justifyContent: 'space-between',  maxWidth: '80%', flexDirection: 'column' }}>
                    <p style={{ marginBlockEnd: '0', display: 'flex',  fontSize: 18, fontWeight: 'bold', overflow: 'hidden', whiteSpace: 'nowrap', TextOverflow: 'ellipsis',  color: 'white'}}>{type === 'service' && item.type}{type === 'venue' && item.name}</p>
                    <p style={{ marginBlockStart: '0.1em', marginBlockEnd: '0.7em', color: 'white' }}>{type === 'service' && item.name}{type === 'venue' && item.address}</p>
                        <p style={{ marginBlockStart: '0.1em', marginBlockEnd: '0.7em', color: 'var(--org)'}}>{type === 'venue' && 'Venue'}</p>
                    
                    
                    <Stars qty={item.qty} offset={item.offset} id={id}/>
                </div>
            </div>
        </div>

    );
}